let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iaViG")).then(() => parcelRequire('7h3zr'));